import { Injectable, signal, computed } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private requestCount = signal(0);
    private visible = signal(false);
    private showTimeout: ReturnType<typeof setTimeout> | null = null;
    private hideTimeout: ReturnType<typeof setTimeout> | null = null;
    private readonly showDelayMs = 150;
    private readonly hideDelayMs = 100;

    isLoading = computed(() => this.visible());

    show() {
        this.requestCount.update(count => count + 1);

        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }

        if (this.showTimeout || this.visible()) return;

        this.showTimeout = setTimeout(() => {
            this.showTimeout = null;
            if (this.requestCount() > 0) {
                this.visible.set(true);
            }
        }, this.showDelayMs);
    }

    hide() {
        this.requestCount.update(count => Math.max(0, count - 1));
        if (this.requestCount() === 0) {
            if (this.showTimeout) {
                clearTimeout(this.showTimeout);
                this.showTimeout = null;
            }

            if (this.hideTimeout) return;

            this.hideTimeout = setTimeout(() => {
                this.hideTimeout = null;
                if (this.requestCount() === 0) {
                    this.visible.set(false);
                }
            }, this.hideDelayMs);
        }
    }
}
